import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { JobFormPage } from "~/pages/JobsFormPage";
import { useJobLabels } from "~/hooks/useJobLabels";
import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute } from "@tanstack/react-router";
import { ErrorBoundary, RouteErrorComponent } from "@quake/shared-ui/components/ui/error-boundary";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/jobs/create")({
  component: RouteComponent,
  loader: async () => {
    const jobCount = await queryClient.fetchQuery(trpc.jobs.jobCount.queryOptions());
    return { jobCount };
  },
  errorComponent: RouteErrorComponent,
});

function RouteComponent() {
  const { jobCount } = Route.useLoaderData();
  const { plural } = useJobLabels();
  useBreadCrumbs([
    { title: plural, link: `/${location.pathname.split("/")[1]}/data/jobs` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/jobs/create` },
  ]);
  return <JobFormPage jobCount={jobCount} />;
}
